// extracted by mini-css-extract-plugin
module.exports = {"heroBannerShopTitle":"HeroBannerShopTitle_heroBannerShopTitle__MBmd5","inverse":"HeroBannerShopTitle_inverse__miBrR","breakWord":"HeroBannerShopTitle_breakWord__1nZ8D"};